import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface PdfRequest {
  templateName: string;
  data: any;
}

export interface XLSXRequest {
  sheetName: string;
  data: string[][];
}

@Injectable({
  providedIn: 'root',
})
export class AssetExportService {
  private readonly assetsToExportSubject = new BehaviorSubject<any[]>([]);
  assetsToExport$ = this.assetsToExportSubject.asObservable();

  constructor(private readonly apiService: ApiService) {}

  generatePDF(request: PdfRequest): Observable<Blob> {
    return this.apiService.newPost('/api/pdf/generate', request, {
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    });
  }

  generateXLSX(request: XLSXRequest): Observable<Blob> {
    return this.apiService.newPost('/api/xlsx/generate', request, {
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    });
  }

  updateAssetsToExport(assets: any[]) {
    this.assetsToExportSubject.next(assets);
  }
}
